export const navlist = [
  {
    id: 1,
    link: "/",
    text: "Order Online",
  },
  {
    id: 2,
    link: "/user-orders",
    textOrder: "My orders",
  },
  {
    id: 3,
    link: "/about",
    text: "About",
  },
  {
    id: 4,
    link: "/login",
    textLogin: "Login",
  },
];
